import React from "react";
import GitHubCalendar from "react-github-calendar";

export default function Stats() {
  return (
    <div className="container-lg text-center mt-5 mb-5">
      <h5 className="IBM-Plex-Mono fs-3 mb-5">Github Statistics</h5>

      <div className="row bg-opacity-50">
        <div className="col-12 m-auto">
          <div className="github-stat">
            <GitHubCalendar username="prathmesh49" />
          </div>
        </div>
        <div className="col-12">
          <div className="github-stat">
            <img
              src="https://github-readme-streak-stats.herokuapp.com/?user=prathmesh49&theme=dark"
              className="img-fluid rounded mx-auto d-block"
              alt="Github Contributions Streak"
              id="github-streak-stats"
            />
          </div>
        </div>
        <div className="col-12">
          <div className="github-stat">
            <img
              src="https://github-readme-stats.vercel.app/api?username=prathmesh49&theme=dark&show_icons=true&count_private=true"
              className="img-fluid rounded mx-auto d-block"
              alt="Github Stats"
              id="github-stats-card"
            />
          </div>
        </div>
        <div className="col-12">
          <div className="github-stat">
            <img
              src="https://github-readme-stats.vercel.app/api/top-langs/?username=prathmesh49&layout=compact"
              className="img-fluid rounded mx-auto d-block"
              alt="Top Programming Languages"
              id="github-top-langs"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
